const findLoadingData = async () => {
    const elements = document.querySelectorAll('.gib-loading');
    let requestData = []
    Array.from(elements).map(el => {
        if(el.getAttribute('data-variants')) {
            const variants = el.getAttribute('data-variants').split(',');
            var detailsElement = el.querySelector('script[data-variant-details]');
            var details = [];
            if (detailsElement) {
                try {
                    details = JSON.parse(detailsElement.textContent);
                } catch (error) {

                }
            } else {

            }
            variants.forEach(variantId => {
                var variantDetails = details.find(v => Number(v.id) == Number(variantId));
                var data = {
                    variantId: variantId,
                    productId: el.getAttribute('data-product'),
                    hasIcon: el.getAttribute('data-icon'),
                    alreadyInCart: "0",
                    element: el,
                    needsVariantDetailsFromSearch: !detailsElement,
                }
                if (variantDetails) {
                    data.fulfillmentService = variantDetails?.fulfillmentService ?? "hertford-warehouse";
                    data.inventoryQuantity = variantDetails?.inventoryQuantity ?? "";
                    data.inventoryPolicy = variantDetails?.inventoryPolicy ?? "";
                    data.inventoryManagement = variantDetails?.inventoryManagement ?? "";
                    data.daysToDispatch = variantDetails?.daysToDispatch ?? "";
                    data.absoluteDaysToDispatch = variantDetails?.absoluteDaysToDispatch ?? "";
                }
                requestData.push(data)
            })
        }else {
            var detailsElement = el.querySelector('script[data-variant-details]');
            var variantDetails = {};
            if (detailsElement) {
                try {
                    variantDetails = JSON.parse(detailsElement.textContent);
                } catch (error) {

                }
            }
            requestData.push({
                variantId: el.getAttribute('data-variant'),
                productId: el.getAttribute('data-product'),
                hasIcon: el.getAttribute('data-icon'),
                alreadyInCart: el.getAttribute('data-in-cart') || "0",
                element: el,
                fulfillmentService: variantDetails?.fulfillmentService ?? "hertford-warehouse",
                inventoryQuantity: variantDetails?.inventoryQuantity ?? "",
                inventoryPolicy: variantDetails?.inventoryPolicy ?? "",
                inventoryManagement: variantDetails?.inventoryManagement ?? "",
                daysToDispatch: variantDetails?.daysToDispatch ?? "",
                absoluteDaysToDispatch: variantDetails?.absoluteDaysToDispatch ?? "",
                needsVariantDetailsFromSearch: !detailsElement,
            })
        }
    })
    requestData = requestData.filter(data => data.variantId !== '' && data.productId !== '');

    await enrichVariantDetailsFromSearch(requestData);

    return requestData;
};

const enrichVariantDetailsFromSearch = async (requestData) => {
    const itemsNeedingDetails = requestData.filter(data => data.needsVariantDetailsFromSearch);
    if (itemsNeedingDetails.length === 0) {
        return;
    }

    const productIds = Array.from(new Set(itemsNeedingDetails.map(data => data.productId).filter(id => id)));
    if (productIds.length === 0) {
        return;
    }

    const query = productIds.map(id => `id:${id}`).join(' OR ');

    try {
        const searchUrl = `/search?q=${encodeURIComponent(query)}&sections=custom-variant-details`;
        const response = await fetch(searchUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        const json = await response.json();
        if (!json['custom-variant-details']) {
            return;
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(json['custom-variant-details'], 'text/html');
        const scripts = doc.querySelectorAll('script[data-variant-details]');

        const variantDetailsByProduct = {};

        Array.from(scripts).forEach(scriptEl => {
            const productId = scriptEl.getAttribute('data-product');
            if (!productId) {
                return;
            }
            try {
                const parsed = JSON.parse(scriptEl.textContent);
                const detailsArray = Array.isArray(parsed) ? parsed : [parsed];
                variantDetailsByProduct[productId] = detailsArray;
            } catch (error) {
                console.log("error", error);
            }
        });

        console.log("variantDetailsByProduct", variantDetailsByProduct);

        itemsNeedingDetails.forEach(item => {
            const detailsArray = variantDetailsByProduct[item.productId];
            if (!detailsArray) {
                return;
            }
            const variantDetails = detailsArray.find(v => Number(v.id) == Number(item.variantId));
            if (!variantDetails) {
                return;
            }

            item.fulfillmentService = variantDetails?.fulfillmentService ?? item.fulfillmentService ?? "";
            item.inventoryQuantity = variantDetails?.inventoryQuantity ?? item.inventoryQuantity ?? "";
            item.inventoryPolicy = variantDetails?.inventoryPolicy ?? item.inventoryPolicy ?? "";
            item.inventoryManagement = variantDetails?.inventoryManagement ?? item.inventoryManagement ?? "";
            item.daysToDispatch = variantDetails?.daysToDispatch ?? item.daysToDispatch ?? "";
            item.absoluteDaysToDispatch = variantDetails?.absoluteDaysToDispatch ?? item.absoluteDaysToDispatch ?? "";
            item.needsVariantDetailsFromSearch = false;
        });

    } catch (error) {

    }
};

const getGibDates = async (requestData) => {
    const url = 'https://charterhouse-shopify-test-app.gadget.app/getDispatchDateTest';


    // Only process a maximum of 30 items
    const batch = requestData.slice(0, 80);

    const batchData = batch.map(data => ({
        product_ids: data.productId,
        variant_id: data.variantId,
        market: "22015344775",
        already_in_cart: data.alreadyInCart,
        fulfillment_service: data?.fulfillmentService ? data?.fulfillmentService : "hertford-warehouse",
        inventory_quantity: data?.inventoryQuantity ?? "",
        inventory_policy: data?.inventoryPolicy ?? "",
        inventory_management: data?.inventoryManagement ?? "",
        days_to_dispatch: data?.daysToDispatch ?? "",
        absolute_days_to_dispatch: data?.absoluteDaysToDispatch ?? "",
    }));

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(batchData),
        });

        const responseData = await response.json();

        const elementsToUpdate = []; // Collect DOM updates

        // Use forEach instead of map to ensure order is preserved when applying data

        // First let's update responseData to be grouped by product
        const groupedData = responseData.reduce((acc, data) => {
            acc[data.product_id] = acc[data.product_id] || [];
            acc[data.product_id].push(data);
            return acc;
        }, {});

        console.log({groupedData, batch});

        // Loop through the grouped data, and then add them to the elements to Update
        Object.keys(groupedData).forEach(productId => {
            let productData;

            if(groupedData[productId].length > 1) {
                //sort to find the in stock + purchasable first
                const sortedData = groupedData[productId].sort((a, b) => {
                    // if(a.in_stock && a.purchasable && b.in_stock && b.purchasable) {
                    //     return 0;
                    // }
                    // return a.in_stock && a.purchasable ? -1 : 1;
                    // First priority: in stock AND purchasable
                    const aBest = a.in_stock && a.purchasable;
                    const bBest = b.in_stock && b.purchasable;
                    if (aBest && bBest) return 0;
                    if (aBest) return -1;
                    if (bBest) return 1;
                    
                    // Second priority: purchasable (even if out of stock)
                    if (a.purchasable && !b.purchasable) return -1;
                    if (b.purchasable && !a.purchasable) return 1;
                });
                productData = sortedData[0];
                console.log({productData}, "Found an available one!")
            }else {
                productData = groupedData[productId][0];
            }
            const originalElement = batch.find(data => data.variantId === productData.variant_id);
            elementsToUpdate.push(() => applyGibDate(originalElement, productData));
        });

        // responseData.forEach((data, index) => {
        //     elementsToUpdate.push(() => applyGibDate(batch[index], data));
        // });

        // Perform DOM updates all at once, in the order they appear
        elementsToUpdate.forEach(updateFn => updateFn());

    } catch (error) {
        console.error('Error in batch request:', error);
    }
};

const getContent = (data, hasIcon) => {

    let icon = "";
    if (hasIcon === "true") {
        if (data.in_stock && data.purchasable) {
            icon = `<i class="fa-fw fa-sharp fa-light fa-circle-check"></i>`;
        } else if (!data.in_stock && data.purchasable) {
            icon = `<i class="fa-fw fa-sharp fa-light fa-clock"></i>`;
        } else {
            icon = `<i class="fa-fw fa-sharp fa-light fa-times"></i>`;
        }
    }


    let content = "";
    if (data.in_stock && data.purchasable) {
        content = `<div class="gib-text gib-text--ok">${icon} Get it by ${data.pretty_earliest_delivery}</div>`;
    } else if (!data.in_stock && data.purchasable) {
        content = `<div class="gib-text gib-text--info">${icon} Stock Expected in ${data.days_to_dispatch}</div>`;
    } else {
        content = `<div class="gib-text gib-text--warn">${icon} Sold out</div>`;
    }

    return content;
}

/**
 * Apply Get It By Dates from batch response
 */
const applyGibDate = ({ element, hasIcon }, data) => {




    element.innerHTML =  getContent(data, hasIcon);
    element.classList.remove("gib-loading");
};

const scheduleGibCheck = async () => {
    const requestData = await findLoadingData();
    if (requestData.length > 0) {
        getGibDates(requestData).then(() => {
            setTimeout(scheduleGibCheck, 500); // Fetch the next batch on next cycle
        });
    } else {
        setTimeout(scheduleGibCheck, 500); // Check again after 1 second if no more elements
    }
};

const handleVariantChange = (selectedVariantId) => {
    const elements = document.querySelectorAll('.gib-container');
    for (const element of elements) {
        const variantId = element.getAttribute('data-variant');
        if (variantId == selectedVariantId) {
            element.style.display = 'block';
        } else {
            element.style.display = 'none';
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    scheduleGibCheck();

    // Check if we're on a product page + register our variant hook
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => { handleVariantChange(event.data.variant.id) });
});
